import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import { getLocalCurrencyStr } from '@beef/utils';

import { Error } from './components/Error';
import styles from './styles.pcss';
import { PriceWrapperProps } from './types';

const cn = classNames.bind(styles);

export const PriceWrapper: FC<PriceWrapperProps> = ({
  priceErrorText,
  isError,
  isPending,
  price,
  children,
}) => {
  if (isError) {
    return <Error text={priceErrorText || ''} />;
  }
  if (isPending) {
    return null;
  }

  return (
    <div className={cn('component')}>
      {(!!price || price === 0) && (
        <Text size="size5-r-s">
          <div className={cn('count')}>{getLocalCurrencyStr(price)}</div>
        </Text>
      )}
      {children}
    </div>
  );
};
